import { render, staticRenderFns } from "./AdministratorEdit.vue?vue&type=template&id=4f524a78&scoped=true&"
import script from "./AdministratorEdit.vue?vue&type=script&lang=js&"
export * from "./AdministratorEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f524a78",
  null
  
)

export default component.exports